import { css } from '@emotion/css';

export const lottie = css`
  width: 5rem;
  height: 5rem;
`;
